<template>
  <div>
    <div class="bs-slider">
      <div
        v-if="SliderPrincipal.length > 0"
        id="sliderAutomatic"
        class="carousel slide"
        data-ride="carousel"
      >
        <div class="carousel-inner">
          <div
            v-for="(value, key) in SliderPrincipal"
            :key="key"
            :class="['carousel-item', key == 0 ? 'active' : '']"
          >
            <img :src="value.imagen" class="d-block w-100" alt="" />
            <div class="carousel-caption">
              <div class="context">
                <h1>{{ value.titulo }}</h1>
                <p v-if="value.subtitulo">{{ value.subtitulo }}</p>
              </div>
            </div>
          </div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-target="#sliderAutomatic"
          data-slide="prev"
        >
          <span class="base-icon">
            <span
              class="carousel-control-prev-icon icon"
              aria-hidden="true"
            ></span>
          </span>
          <span class="sr-only">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-target="#sliderAutomatic"
          data-slide="next"
        >
          <span class="base-icon">
            <span
              class="carousel-control-next-icon icon"
              aria-hidden="true"
            ></span>
          </span>
          <span class="sr-only">Next</span>
        </button>
      </div>
    </div>
    <section class="section-birthday container-fluid">
      <div class="birthday container">
        <div class="row p-0 m-0 d-flex justify-content-between">
          <div class="col-md-4 p-0 m-0">
            <div class="box">
              <h3>Vea los cumpleañeros de hoy</h3>
              <h1>{{ fecha_onomastico }}</h1>
              <a href="/onomastico" class="caja-link">
                <i class="fa fa-arrow-right"></i>
              </a>
            </div>
          </div>
          <div class="col-md-4" style="position: relative">
            <div class="msg-hb">
              <p>
                Hoy es un día especial para brillar como la estrella que eres, ¡
                <strong style="font-weight: 900">Feliz cumpleaños</strong>!
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="hb">
              <img src="/img/hb.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-events-courses container-fluid">
      <div class="events-courses container">
        <div class="wrapper">
          <div class="col-md-6">
            <div class="box">
              <img src="img/women.png" alt="" />
              <div class="context">
                <h1>Cursos</h1>
                <p>
                  Explora nuestra variada oferta de cursos diseñados para
                  profesionales y estudiantes interesados en actualizar y
                  profundizar sus conocimientos en diversas áreas de la
                  profesión.
                </p>
                <a href="/cursos">
                  <i class="fa fa-arrow-right"></i>
                </a>
                <span class="float-number">{{ cant_cursos }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="box">
              <img src="img/man.png" alt="" />
              <div class="context">
                <h1>Eventos</h1>
                <p>
                  Mantente al día con los próximos eventos dedicados a la
                  comunidad veterinaria. Participa en seminarios, conferencias y
                  talleres diseñados para expandir tu red profesional.
                </p>
                <a href="/eventos">
                  <i class="fa fa-arrow-right"></i>
                </a>
                <span class="float-number">{{ cant_eventos }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="section-process container-fluid"
      id="process"
      style="background-image: url('/img/process.jpg')"
    >
      <div class="process container">
        <div class="text-center mb-5">
          <h1 class="section-title text-white">Trámites</h1>
          <h6 class="section-subtitle">NUESTRO TRÁMITES A TU DISPOSICIÓN</h6>
        </div>
        <div class="col">
          <div class="all-process">
            <div
              v-for="(value, key) in Tramites.slice(0, 4)"
              :key="key"
              class="col-md-3"
            >
              <div
                class="featured-box featured-box-primary featured-box-effect-3"
              >
                <a :href="'/tramite/' + value.id" class="box-content">
                  <span>
                    <i class="fa" :class="value.icono"></i>
                  </span>
                  <h4 class="pt-4 text-black font-weight-light">
                    {{ value.titulo }} <br />
                    <strong style="font-weight: 900">{{
                      value.subtitulo
                    }}</strong>
                  </h4>
                  <p class="text-black font-weight-light">
                    {{ value.descripcion }}
                  </p>
                  <i class="fa fa-eye"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="more-divider">
            <a
              v-if="Tramites.length > 5"
              href="/tramites"
              class="bg-white text-brown"
              >Ver más <i class="fa fa-arrow-right ml-2"></i
            ></a>
          </div>
        </div>
      </div>
    </section>

    <section class="section-services container-fluid" id="services">
      <div class="services container">
        <div class="text-center mb-5">
          <h1 class="section-title text-brown">Servicios</h1>
          <h6 class="section-subtitle">NUESTROS SERVICIOS A SU DISPOSICIÓN</h6>
        </div>
        <div class="wrapper">
          <a href="/mesa_partes_virtual" class="stack">
            <div class="icon">
              <i class="fa-solid fa-book-open"></i>
            </div>
            <div class="text">
              <h5>Mesa de partes Virtual</h5>
              <p>
                Permite a los colegiados y ciudadanos en general realizar
                trámites administrativos de manera completamente en línea.
              </p>
            </div>
          </a>
          <a href="/busqueda_colegiado" class="stack">
            <div class="icon">
              <i class="fa-solid fa-magnifying-glass"></i>
            </div>
            <div class="text">
              <h5>Búsqueda colegiados</h5>
              <p>
                Este servicio permite a los usuarios consultar el registro
                oficial de los médicos veterinarios colegiados en nuestra
                institución.
              </p>
            </div>
          </a>
          <a href="/estadisticas_colegiados" class="stack">
            <div class="icon">
              <i class="fa-solid fa-magnifying-glass"></i>
            </div>
            <div class="text">
              <h5>Estadística Colegiados</h5>
              <p>
                Es una herramienta útil para entender mejor las tendencias en el
                registro profesional sobre la composición de género en los
                diferentes años.
              </p>
            </div>
          </a>
        </div>
        <div class="more-divider">
          <a href="/servicios/"
            >Ver más <i class="fa fa-arrow-right ml-2"></i
          ></a>
        </div>
      </div>
    </section>

    <section
      v-if="Comunicado.id || Pronunciamiento.id"
      class="section-comun-pronun overlay container-fluid"
      style="background-image: url('img/news.jpg')"
    >
      <div class="comun-pronun container">
        <div class="text-center mb-5">
          <h1 class="section-title text-white">
            Comunicados y Pronunciamientos
          </h1>
          <h6 class="section-subtitle">
            Conoce los comunicados y pronunciamientos del CMVDSM
          </h6>
        </div>
        <div class="wrapper">
          <div v-if="Comunicado.id" class="col-md-6">
            <div class="box">
              <div class="image">
                <img :src="Comunicado.imagen" alt="" />
              </div>
              <div class="context">
                <div class="float-date">
                  <span>{{ Comunicado.fecha }}</span>
                </div>
                <p class="text-muted font-weight-bold">ÚLTIMO COMUNICADO</p>
                <h3>
                  <a :href="'/comunicado/' + Comunicado.id">{{
                    Comunicado.titulo
                  }}</a>
                </h3>
                <p v-html="Comunicado.descripcion"></p>
                <span>
                  <a :href="'/comunicado/' + Comunicado.id">
                    <i class="fa fa-plus mr-2"></i>
                    <small></small>
                    <small> Leer más</small>
                  </a>
                </span>
              </div>
            </div>
          </div>

          <div v-if="Pronunciamiento.id" class="col-md-6">
            <div class="box">
              <div class="image">
                <img :src="Pronunciamiento.imagen" alt="" />
              </div>
              <div class="context">
                <div class="float-date">
                  <span>{{ Pronunciamiento.fecha }}</span>
                </div>
                <p class="text-muted font-weight-bold">
                  ÚLTIMO PRONUNCIAMIENTO
                </p>
                <h3>
                  <a :href="'/pronunciamiento/' + Pronunciamiento.id">{{
                    Pronunciamiento.titulo
                  }}</a>
                </h3>
                <p v-html="Pronunciamiento.descripcion"></p>
                <span>
                  <a :href="'/pronunciamiento/' + Pronunciamiento.id">
                    <i class="fa fa-plus mr-2"></i>
                    <small></small>
                    <small> Leer más</small>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div id="show-comunicate" v-if="showComunicado && SliderFlotante.length">
      <div class="base">
        <div class="principal">
          <img src="img/modal.png" alt="" />
          <div class="title">
            <!-- Grupo de Comunicados -->
            <template v-if="comunicados.length">
              <h1>
                <br />
                Comunicado
              </h1>
              <ul>
                <li v-for="item in comunicados" :key="'comunicado-' + item.id">
                  <a :href="'comunicado/' + item.id">{{ item.titulo }}</a>
                </li>
              </ul>
            </template>

            <!-- Grupo de Pronunciamientos -->
            <template v-if="pronunciamientos.length">
              <h1>
                <br />
                Pronunciamiento
              </h1>
              <ul>
                <li
                  v-for="item in pronunciamientos"
                  :key="'pronunciamiento-' + item.id"
                >
                  <a :href="'pronunciamiento/' + item.id">{{ item.titulo }}</a>
                </li>
              </ul>
            </template>
          </div>
        </div>
        <div class="close" @click="closeComunicado">
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "Web",
  computed: {
    ...mapState(["empresa"]),
    comunicados() {
      return this.SliderFlotante.filter((item) => item.tipo === "COMUNICADO");
    },
    pronunciamientos() {
      return this.SliderFlotante.filter(
        (item) => item.tipo === "PRONUNCIAMIENTO"
      );
    },
  },
  components: {},
  created() {},
  mounted() {
    document.title =
      "Bienvenido al CMVSM "
    this.getPrincipal();
  },
  data() {
    return {
      SliderPrincipal: [],
      SliderFlotante: [],
      Tramites: [],
      Comunicado: {
        id: "",
        titulo: "",
        descripcion: "",
        imagen: "",
        fecha: "",
      },
      Pronunciamiento: {
        id: "",
        titulo: "",
        descripcion: "",
        imagen: "",
        fecha: "",
      },
      fecha_onomastico: "",
      cant_cursos: 0,
      cant_eventos: 0,
      showComunicado: true,
    };
  },
  methods: {
    ...mapMutations(["setLoading"]),

    getPrincipal() {
      this.setLoading(true);
      this.$http.get("ws_principal/main_web").then((res) => {
        this.SliderPrincipal = res.data.Slider_principal;
        this.SliderFlotante = res.data.Slider_flotante;
        this.Tramites = res.data.Tramites;
        this.Comunicado = res.data.Comunicado;
        this.Pronunciamiento = res.data.Pronunciamiento;
        this.fecha_onomastico = res.data.fecha_onomastico;
        this.cant_cursos = res.data.cant_cursos;
        this.cant_eventos = res.data.cant_eventos;
        this.setLoading(false);
      });
    },
    comunicados() {
      return this.SliderFlotante.filter((item) => item.tipo === "COMUNICADO");
    },
    pronunciamientos() {
      return this.SliderFlotante.filter(
        (item) => item.tipo === "PRONUNCIAMIENTO"
      );
    },
    closeComunicado() {
      this.showComunicado = false;
    },
  },
};
</script>
